// import { Directive, HostListener } from '@angular/core'
// import { NgControl } from '@angular/forms'

// @Directive({
//   selector: '[appTrimInput]'
// })
// export class TrimInputDirective {
//   constructor(private ngControl: NgControl) {}

//   @HostListener('blur')
//   onBlur() {
//     const control = this.ngControl.control
//     if (control && typeof control.value === 'string' && control.value !== control.value.trim()) {
//       control.setValue(control.value.trim())
//     }
//   }
// }

import { Directive, HostListener, Optional } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[appTrimInput]',
  standalone: true
})
export class TrimInputDirective {
  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('blur')
  onBlur() {
    // if (this.ngControl?.control && typeof this.ngControl.control.value === 'string') {
    //   this.ngControl.control.setValue(this.ngControl.control.value.trim())
    const control = this.ngControl?.control
    const value = control?.value

    if (control && typeof value === 'string') {
      const trimmed = value.trim()
      if (trimmed !== value) {
        control.setValue(trimmed, { emitEvent: true })
        control.updateValueAndValidity() // re-run validators for this control
      }
    }
  }
}
